module.exports = __webpack_public_path__ + "img/acmmm2021_logo.1f9d3343.png";